module.exports = __webpack_public_path__ + "static/img/RE13.c94f596.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE13.jpg
// module id = qlrD
// module chunks = 0